import { useAtom } from "jotai";
import React, { createContext, useContext, useEffect, useState } from "react";
import { Data, data } from "../config/data";
import { ticketAtom, workOrderIDAtom } from "../store";

import useMerchant from "../hooks/useMerchant";
import { useNavigate, useLocation } from "react-router-dom";


interface AppContextValue {
  mockData: Data;
  setData: React.Dispatch<React.SetStateAction<any>>;
}

const AppContext = createContext<AppContextValue | null>(null);

interface AppProviderProps {}
const AppProvider = ({
  children,
}: React.PropsWithChildren<AppProviderProps>) => {
  const [mockData, setData] = useState(data);
  const [ticketData, ] = useAtom(ticketAtom);
  const [ workOrderID, setWorkOrderId ] = useAtom(workOrderIDAtom)
  const { fetch: fetchMerchant } = useMerchant();
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(()=>{
    if(ticketData)setWorkOrderId(ticketData.id)
    else setWorkOrderId("")
  },[ticketData])


  useEffect(() => {
    fetchMerchant({
      onError: () => {
        navigate('/error')
      },
      onSuccess: () => {
        if(location.pathname === '/error'){
          navigate('/')
        }
      },
    });
  }, []);

  return (
    <AppContext.Provider value={{  mockData, setData }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) throw new Error("use useAppContext inside AppProvider");

  return context;
};
